import { useEffect, useState } from 'react';

import { StorageOfUniqueServices } from '@qality/common-service';

export default function useProjectDashboardUrl(projectKey, projectId) {
  const [projectDashboardUrl, setProjectDashboardUrl] = useState('');

  useEffect(() => {
    const init = async () => {
      setProjectDashboardUrl(
        await StorageOfUniqueServices.get('URLService').getProjectDashboardUrl(
          projectKey,
          projectId
        )
      );
    };
    init();
  });

  return projectDashboardUrl;
}
